module.exports = __webpack_public_path__ + "img/object_utilgg.6141ffc6.svg";